import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const UserComponent = () => {
  return (
    <>
      <Helmet>
        <title>User | Admin</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default UserComponent;
